module.exports = __webpack_public_path__ + "static/media/prescon-parawajah-indonesia.d2005954.jpg";